import { render, staticRenderFns } from "./UpdateLog.vue?vue&type=template&id=0ad81e86&scoped=true&"
import script from "./UpdateLog.vue?vue&type=script&lang=js&"
export * from "./UpdateLog.vue?vue&type=script&lang=js&"
import style0 from "./UpdateLog.vue?vue&type=style&index=0&id=0ad81e86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad81e86",
  null
  
)

export default component.exports